import { SLOW_INTERVAL } from 'config/constants'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'state'
import useSWRImmutable from 'swr/immutable'
// import { useBCakeProxyContractAddress } from 'views/Farms/hooks/useBCakeProxyContractAddress'
import { getMasterChefContract } from 'utils/contractHelpers'
import { getFarmConfig } from '@pancakeswap/farms/constants'
import {
  DeserializedFarm,
  DeserializedFarmsState,
  DeserializedFarmUserData,
  supportedChainIdV2,
} from '@pancakeswap/farms'
import { useActiveChainId } from 'hooks/useActiveChainId'

import useAccountActiveChain from 'hooks/useAccountActiveChain'
import { fetchFarmPrices, fetchFarmsPublicDataAsync, fetchFarmUserDataAsync } from '.'
import {
  farmSelector,
  makeFarmFromPidSelector,
  makeLpTokenPriceFromLpSymbolSelector,
  makeUserFarmFromPidSelector,
} from './selectors'
// import { useSlowRefreshEffect } from 'hooks/useRefreshEffect'
// import { fetchTokenPrices } from 'views/Info/hooks/useBnbPrices'

export function useFarmsLength() {
  const { chainId } = useActiveChainId()
  return useSWRImmutable(
    chainId && supportedChainIdV2.includes(chainId) ? ['farmsLength', chainId] : null,
    async () => {
      const mc = getMasterChefContract(undefined, chainId)
      return Number(await mc.read.poolLength())
    },
  )
}

export const usePollFarmsWithUserData = () => {
  const dispatch = useAppDispatch()
  const { account, chainId } = useAccountActiveChain()
  // const {
  //   proxyAddress,
  //   proxyCreated,
  //   isLoading: isProxyContractLoading,
  // } = useBCakeProxyContractAddress(account, chainId)

  useSWRImmutable(
    chainId && supportedChainIdV2.includes(chainId) ? ['publicFarmData', chainId] : null,
    async () => {
      const farmsConfig = await getFarmConfig(chainId)
      if (!farmsConfig) return
      const pids = farmsConfig.map((farmToFetch) => farmToFetch.pid)

      dispatch(fetchFarmsPublicDataAsync({ pids, chainId }))
      dispatch(fetchFarmPrices({ chainId }))
    },
    {
      refreshInterval: SLOW_INTERVAL,
    },
  )

  useSWRImmutable(
    account && chainId ? ['farmsWithUserData', account, chainId] : null,
    async () => {
      const farmsConfig = await getFarmConfig(chainId)
      if (!farmsConfig) return
      const pids = farmsConfig.map((farmToFetch) => farmToFetch.pid)
      dispatch(fetchFarmUserDataAsync({ account, pids, chainId }))
    },
    {
      refreshInterval: SLOW_INTERVAL,
    },
  )
}

export const useFarms = (): DeserializedFarmsState => {
  const { chainId } = useActiveChainId()
  return useSelector(useMemo(() => farmSelector(chainId), [chainId]))
}

export const useFarmFromPid = (pid: number): DeserializedFarm => {
  const farmFromPid = useMemo(() => makeFarmFromPidSelector(pid), [pid])
  return useSelector(farmFromPid)
}

export const useFarmUser = (pid): DeserializedFarmUserData => {
  const farmFromPidUser = useMemo(() => makeUserFarmFromPidSelector(pid), [pid])
  return useSelector(farmFromPidUser)
}

export const useLpTokenPrice = (symbol: string) => {
  const lpTokenPriceFromLpSymbol = useMemo(() => makeLpTokenPriceFromLpSymbolSelector(symbol), [symbol])
  return useSelector(lpTokenPriceFromLpSymbol)
}
